// extracted by mini-css-extract-plugin
module.exports = {"root":"IconValueStar_root_vuBlO","icon":"IconValueStar_icon_2zTz0","value":"IconValueStar_value_2TAWK"};